"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var exceptions_1 = require("../exceptions");

exports.resolveInMS = function (p, timeout) {
  if (timeout === void 0) {
    timeout = 5000;
  }

  return Promise.race([p(), new Promise(function (_, reject) {
    setTimeout(function () {
      return reject(new exceptions_1.TimeOutError(timeout / 1000));
    }, timeout);
  })]);
};